import React, { useEffect } from "react"
import { handleAuthentication } from "dAuth"
import Loading from "organisms/common/Loading"

const Callback = (props) => {
  useEffect(() => {
    handleAuthentication()
  }, [props])

  return <Loading />
}

export default Callback
